import { css } from 'styled-components';

export const Boxy = css`
  border: 2px solid black;
  background-color: white;
  box-shadow: var(--title-box-offset) var(--title-box-offset) 0
    var(--boxy-color);
`;
